import type { QueryClient } from '@tanstack/react-query'
import { orgProduct } from '@/lib/queries/org-products'
import {
  bucketPublicStatusQuery,
  getSupabaseAssetUrl,
} from '@/lib/supabase/storage'

const IMAGE_TRANSFORM_OPTIONS = { imageTransform: { quality: 85 } }
const STALE_TIME = 12 * 60 * 60 * 1000 // 12 hours

export async function prefetchProductImages(
  queryClient: QueryClient,
  productId: string
): Promise<void> {
  const product = await queryClient.query(orgProduct.findOne(productId))
  const images = product.org_product_images
  if (images.length === 0) {
    return
  }

  const isPublic = await queryClient.query(
    bucketPublicStatusQuery('generations')
  )

  const urlResults = await Promise.allSettled(
    images.map((img) =>
      queryClient.query({
        queryKey: [
          'supabase-asset',
          'generations',
          img.storage_path,
          IMAGE_TRANSFORM_OPTIONS,
        ],
        queryFn: () =>
          getSupabaseAssetUrl(
            'generations',
            img.storage_path,
            isPublic,
            IMAGE_TRANSFORM_OPTIONS
          ),
        staleTime: STALE_TIME,
      })
    )
  )

  // Trigger browser image cache preload
  for (const result of urlResults) {
    if (result.status === 'fulfilled') {
      new Image().src = result.value
    }
  }
}
